import type { Activity } from "@/types/data.types";

let cache: Activity[] | null = null;
let inFlight: Promise<Activity[]> | null = null;

function shiftDatesToToday(rows: Activity[]): Activity[] {
  // Collect valid dates
  const times = rows
    .map((r) => (r.start_date ? new Date(r.start_date).getTime() : null))
    .filter((t): t is number => typeof t === "number" && Number.isFinite(t));

  // If nothing to shift, return as-is
  if (times.length === 0) return rows;

  const latestMs = Math.max(...times);

  // Anchor latest date to "today at 00:00" in the user's local timezone
  const now = new Date();
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const targetMs = todayStart.getTime();

  const deltaMs = targetMs - latestMs;

  // Shift all valid start_date values by delta
  return rows.map((r) => {
    if (!r.start_date) return r;

    const t = new Date(r.start_date).getTime();
    if (!Number.isFinite(t)) return r;

    return {
      ...r,
      start_date: new Date(t + deltaMs).toISOString(),
    };
  });
}

export function loadDemoActivities(): Promise<Activity[]> {
  if (cache) return Promise.resolve(cache);
  if (inFlight) return inFlight;

  inFlight = fetch("/demo/activities.json")
    .then((res) => {
      if (!res.ok) throw new Error("Failed to load demo activities.json");
      return res.json() as Promise<Activity[]>;
    })
    .then((json) => {
      const shifted = shiftDatesToToday(json);
      cache = shifted;
      return shifted;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}
